import React, { FC } from 'react';

import { Modal, ModalOverlay, ModalContent } from '@vimeo/bokeh';

import ReviewAsGuestForm from './ReviewAsGuestForm';

interface Props {
  xsrft: string;
  closeModal: () => void;
  onSuccessfulLogin: (response: { signup: boolean }) => void;
  submitCommentAsGuest: (guestName: string, guestEmail?: string) => void;
  isActive: boolean;
  isSubmitLoading?: boolean;
  apiErrorCode?: number | null;
  resetApiErrorCode?: (errorCode: number) => void | undefined;
  titleText?: string;
  submitButtonText?: string;
  canReactToCollabComments?: boolean;
}

const ReviewAsGuestModal: FC<Props> = ({
  xsrft,
  closeModal,
  onSuccessfulLogin,
  submitCommentAsGuest,
  isActive,
  isSubmitLoading = false,
  apiErrorCode = null,
  resetApiErrorCode,
  titleText,
  submitButtonText,
  canReactToCollabComments,
}) => {
  return (
    <Modal isOpen={isActive} onClose={closeModal} size="sm">
      <ModalOverlay />
      <ModalContent maxW="418px">
        <ReviewAsGuestForm
          closeModal={closeModal}
          xsrft={xsrft}
          onSuccessfulLogin={onSuccessfulLogin}
          submitCommentAsGuest={submitCommentAsGuest}
          isSubmitLoading={isSubmitLoading}
          apiErrorCode={apiErrorCode}
          resetApiErrorCode={resetApiErrorCode}
          titleText={titleText}
          submitButtonText={submitButtonText}
          canReactToCollabComments={canReactToCollabComments}
        />
      </ModalContent>
    </Modal>
  );
};

export default ReviewAsGuestModal;
